import api from "./api";

// 新增
export const addActivity = params => {
  return api("post", `/v1/management/native-landing-page-config/add`, params);
};

// 列表
export const activityList = params => {
  return api("post", `/v1/management/native-landing-page-config/list`, params);
};

// 编辑
export const editActivity = params => {
  return api("post", `/v1/management/native-landing-page-config/edit`, params);
};

// 详情
export const activityInfo = id => {
  return api("get", `/v1/management/native-landing-page-config/detail/${id}`);
};

// 删除
export const deleteActivity = id => {
  return api("delete", `/v1/management/native-landing-page-config/${id}`);
};

// 预览
export const previewActivity = id => {
  return api("post", `/v1/management/native-landing-page-config/preview/${id}`);
};

// 发布
export const publishActivity = params => {
  return api("post", `/v1/management/native-landing-page-config/publish`, params);
};

// 下架
export const offlineActivity = id => {
  return api("post", `/v1/management/native-landing-page-config/off-shelf/${id}`);
};

